module.exports = __webpack_public_path__ + "img/dateDDM.81892430.png";